import { MARQUEE_ITEMS } from "@/data/site";

export default function Marquee() {
  const doubled = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative z-10 overflow-hidden border-y border-black/20 bg-[#3B82F6] py-3"
    >
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {doubled.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="font-mono2 flex items-center whitespace-nowrap px-6 text-sm font-bold uppercase tracking-[0.25em] text-white"
              >
                {item}
                <span className="ml-12 inline-block h-1.5 w-1.5 rotate-45 bg-white/70" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
